import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps } from '@wordpress/block-editor';
import { 
    MediaUpload, 
    MediaUploadCheck, 
    RichText,
    InspectorControls 
} from '@wordpress/block-editor';
import { 
    Button, 
    PanelBody, 
    SelectControl,
    Notice,
    TextControl
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

registerBlockType('puroclean/veterans-section', {
    edit({ attributes, setAttributes }) {
        const { imageId, imageUrl, imageAlt, heading, linkUrl } = attributes;
        
        const blockProps = useBlockProps({
            className: 'veterans-section'
        });

        // Default image fallback
        const defaultImageUrl = '/wp-content/themes/puroclean-tw/assets/img/purovet.png';
        const displayImageUrl = imageUrl || defaultImageUrl;

        const onSelectImage = (media) => {
            setAttributes({
                imageId: media.id,
                imageUrl: media.url,
                imageAlt: media.alt || 'PuroVet Logo'
            });
        };

        const onRemoveImage = () => {
            setAttributes({
                imageId: 0,
                imageUrl: '',
                imageAlt: 'PuroVet Logo'
            });
        };

        return (
            <>
                <InspectorControls>
                    <PanelBody title={__('Image Settings', 'puroclean')} initialOpen={true}>
                        <MediaUploadCheck>
                            <MediaUpload
                                onSelect={onSelectImage}
                                allowedTypes={['image']}
                                value={imageId}
                                render={({ open }) => (
                                    <div>
                                        {displayImageUrl && (
                                            <div style={{ marginBottom: '10px' }}>
                                                <img 
                                                    src={displayImageUrl} 
                                                    alt={imageAlt}
                                                    style={{ 
                                                        width: '110px', 
                                                        height: '124px',
                                                        objectFit: 'contain',
                                                        border: '1px solid #ddd'
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <Button 
                                            onClick={open} 
                                            variant="secondary"
                                            style={{ marginRight: '10px' }}
                                        >
                                            {imageId ? __('Change Image', 'puroclean') : __('Select Image', 'puroclean')}
                                        </Button>
                                        {imageId > 0 && (
                                            <Button 
                                                onClick={onRemoveImage}
                                                variant="link"
                                                isDestructive
                                            >
                                                {__('Use Default', 'puroclean')}
                                            </Button>
                                        )}
                                    </div>
                                )}
                            />
                        </MediaUploadCheck>
                    </PanelBody>
                    <PanelBody title={__('Link Settings', 'puroclean')} initialOpen={false}>
                        <TextControl
                            label={__('Link URL', 'puroclean')}
                            value={linkUrl}
                            onChange={(value) => setAttributes({ linkUrl: value })}
                            placeholder="/purovet/"
                            help={__('Enter the URL where the veterans section should link to', 'puroclean')}
                        />
                    </PanelBody>
                </InspectorControls>

                <div {...blockProps}>
                    <div className="py-6 bg-white">
                        <div className="max-w-content mx-auto p-4 flex justify-center items-center">
                                <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <img 
                                        className="w-[94px] h-[105px] md:w-[110px] md:h-[124px] object-contain" 
                                        src={displayImageUrl}
                                        alt={imageAlt}
                                    />
                                </div>
                                <div className="ml-6">
                                    <RichText
                                        tagName="h2"
                                        className="~text-2xl/3xl font-bold m-0"
                                        value={heading}
                                        onChange={(value) => setAttributes({ heading: value })}
                                        placeholder={__('Enter heading text...', 'puroclean')}
                                        allowedFormats={[]}
                                        multiline={false}
                                        __unstableDisableFormats={true}
                                    />
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
            </>
        );
    },
    save() {
        return null; // Server-side rendered
    }
}); 